var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon",style:({ width: `${_vm.$attrs.width}px`, height: `${_vm.$attrs.height}px` })})
}
var staticRenderFns = []

export { render, staticRenderFns }